module.exports = __webpack_public_path__ + "img/xj／pic.036b56c1.png";